import type { Theme } from "@mui/material";
import {
	CheckCircle2,
	Clock,
	Info,
	type LucideIcon,
	TriangleAlert,
} from "lucide-react";
import type {
	EventTense,
	EventVariant,
} from "web_myplann/NotificationCenter/EventAlert/types";

export type AlertTone = {
	bg: string;
	border: string;
	iconBg: string;
	iconColor: string;
	titleColor: string;
	ctaButtonColor: "warning" | "info" | "orange" | "neutral";
	Icon: LucideIcon;
};

export type AlertToneKey = "urgent" | "info" | "pastAction" | "pastInfo";

export const getAlertToneKey = (
	tense: EventTense,
	variant: EventVariant,
): AlertToneKey => {
	if (tense === "past") {
		return variant === "warning" ? "pastAction" : "pastInfo";
	}
	return variant === "warning" ? "urgent" : "info";
};

export const getAlertTone = (
	palette: Theme["palette"],
	key: AlertToneKey,
): AlertTone => {
	switch (key) {
		case "urgent":
			return {
				bg: palette.amber[50],
				border: palette.amber[200],
				iconBg: palette.amber[100],
				iconColor: palette.amber[600],
				titleColor: palette.amber[800],
				ctaButtonColor: "warning",
				Icon: TriangleAlert,
			};
		case "info":
			return {
				bg: palette.blue[50],
				border: palette.blue[200],
				iconBg: palette.blue[100],
				iconColor: palette.blue[600],
				titleColor: palette.blue[800],
				ctaButtonColor: "info",
				Icon: Info,
			};
		case "pastAction":
			return {
				bg: palette.orange[50],
				border: palette.orange[200],
				iconBg: palette.orange[100],
				iconColor: palette.orange[600],
				titleColor: palette.orange[800],
				ctaButtonColor: "orange",
				Icon: Clock,
			};
		case "pastInfo":
			return {
				bg: palette.grey[50],
				border: palette.grey[200],
				iconBg: palette.grey[100],
				iconColor: palette.grey[500],
				titleColor: palette.grey[700],
				ctaButtonColor: "neutral",
				Icon: CheckCircle2,
			};
	}
};
